import { useState } from "react";
import PropTypes from "prop-types";
// react mui
import { CircularProgress, Grid, Typography } from "@mui/material";

// intl
import { useIntl } from "react-intl";
import translations from "utils/translations";

// react router dom
import { useLocation } from "react-router-dom";

// use-http
import useFetch from "use-http";

// fields
import AnagraficheFields from "./Anagrafiche.fields";

// constants
import { apiSectorOfInterests } from "constants/api";
import { REGISTER } from "constants/routes";

// components
import { TextFieldControl, MultiSelectControl } from "components/index";

function ProfessionalFields({ control, errors, watch, reset }) {
  // Hooks
  const intl = useIntl();
  const i18n = translations.templates.ProfileForm(intl).page.professional;
  const { pathname } = useLocation();

  // state
  // eslint-disable-next-line
  const [sectors, setSectors] = useState(watch("sectors"));

  const { data, loading, error } = useFetch(apiSectorOfInterests.API_BASE, []);

  return (
    <>
      <Grid mt={1} container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"name"}
            placeholder={i18n.professionalName.label}
            label={i18n.professionalName.label}
            errors={errors}
            errorObj={i18n.professionalName.errors}
            isRequired
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"surname"}
            placeholder={i18n.professionalSurname.label}
            label={i18n.professionalSurname.label}
            errors={errors}
            errorObj={i18n.professionalSurname.errors}
            isRequired
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"email"}
            placeholder={i18n.email.label}
            label={i18n.email.label}
            errors={errors}
            errorObj={i18n.email.errors}
            isRequired
            disabled={pathname !== REGISTER}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          {error && <Typography>{i18n.sector.errors.fetchError}</Typography>}
          {loading && <CircularProgress size={25} />}
          {data?.data && (
            <MultiSelectControl
              control={control}
              name={"sectors"}
              placeholder={i18n.sector.label}
              label={i18n.sector.label}
              errors={errors}
              errorObj={i18n.sector.errors}
              options={data.data}
              value={sectors}
              defaultValue={sectors}
              fullWidth
            />
          )}
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"qualification"}
            placeholder={i18n.qualification.label}
            label={i18n.qualification.label}
            errors={errors}
            errorObj={i18n.qualification.errors}
          />
        </Grid>
        <AnagraficheFields
          reset={reset}
          watch={watch}
          control={control}
          errors={errors}
        />
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"mobile"}
            placeholder={i18n.mobile.label}
            label={i18n.mobile.label}
            errors={errors}
            errorObj={i18n.mobile.errors}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"website"}
            placeholder={i18n.website.label}
            label={i18n.website.label}
            errors={errors}
            errorObj={i18n.website.errors}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextFieldControl
            control={control}
            name={"company"}
            placeholder={i18n.company.label}
            label={i18n.company.label}
            errors={errors}
            errorObj={i18n.company.errors}
          />
        </Grid>
      </Grid>
    </>
  );
}

ProfessionalFields.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  watch: PropTypes.func,
  reset: PropTypes.func,
};
export default ProfessionalFields;
